/** Normalize GraphQL/Mongo-style ids to string */
export const normalizeEntryRefId = (raw) => {
  if (raw == null || raw === '') return null;
  if (typeof raw === 'string' || typeof raw === 'number') return String(raw);
  if (typeof raw === 'object') {
    if (raw.id != null) return String(raw.id);
    if (raw._id != null) return normalizeEntryRefId(raw._id);
    if (raw.$oid != null) return String(raw.$oid);
  }
  return null;
};

export const isDevengadoSourceEntry = (entry) => {
  const ownId = normalizeEntryRefId(entry?.id ?? entry?._id);
  const sourceId = normalizeEntryRefId(entry?.devengadoInformation?.sourceEntryId);
  return !!ownId && !!sourceId && ownId === sourceId;
};

export const countDevengoAccrualEntries = (entry) => {
  const info = entry?.devengadoInformation;
  if (!info) return 0;
  const devengoIds = (info.devengoEntryIds || [])
    .map((id) => String(id))
    .filter(Boolean);
  if (devengoIds.length > 0) return devengoIds.length;
  return Number(info.totalMonths) > 0 ? Number(info.totalMonths) : 0;
};

/** i18n key + optional interpolation values for delete confirmation. */
export const getDeleteEntryConfirmMessage = (entry, t) => {
  if (isDevengadoSourceEntry(entry)) {
    const count = countDevengoAccrualEntries(entry);
    return t('entries.deleteConfirmDevengado', { count });
  }
  if (entry?.reversedInformation?.reverseCounterPartId) {
    return t('entries.deleteConfirmReversal');
  }
  return t('entries.deleteConfirm');
};
